import { combineReducers } from 'redux';
import auth from './auth/authReducer';
import billingAddress from './billingAddress/billingAddressReducer';
import limits from './limits/limitsReducer';
import ssh from './ssh/sshReducer';
import user from './user/userReducer';
import { reducer as adCampaigns } from './adCampaignsModule';
import { reducer as details } from './detailsModule';
import { reducer as invoicesAndPaymentsTimeline } from './invoicesAndPaymentsTimelineModule';
import { reducer as signup } from './signupModule';

export default combineReducers({
	adCampaigns,
	auth,
	billingAddress,
	details,
	invoicesAndPaymentsTimeline,
	limits,
	signup,
	ssh,
	user,
});
